import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../store/store";
import { selectQlikObjectByName } from "../store/slice/qlikObjectSlice";

interface QlikObject {
  layout?: {
    title?: string;
    subtitle?: string;
    qHyperCube?: {
      qGrandTotalRow?: { qText?: string }[];
      qMeasureInfo?: { qFallbackTitle?: string }[];
      qCalcCondMsg?: string;
    };
  };
}

export const useQlikObject = (vizName: string) => {
  const [isQlikLoading, setIsQlikLoading] = useState(false);
  const qlikObject = useSelector((state: RootState) => selectQlikObjectByName(state, vizName))

  // Fetch Qlik object when `vizName` changes
  // useEffect(() => {
  //   const fetchQlikObject = async () => {
  //     if (!vizName) return;
  //     setIsQlikLoading(true);
  //   //   const fetchedQlikObject = await getQlikObject(vizName);
  //   //   setQlikObject(fetchedQlikObject);
  //     setIsQlikLoading(false);
  //   };

  //   fetchQlikObject();
  // }, [vizName]);

  // Computed properties
  const qlikObjectData = useMemo(() => {
    return qlikObject?.qHyperCube?.qDataPages[0]?.qMatrix || [];
  }, [qlikObject]);

  const qlikKpiObjectValue = useMemo(() => {
    return qlikObject?.qHyperCube?.qDataPages[0]?.qMatrix[0][0]?.qText || "-";
  }, [qlikObject]);

  const qlikObjectTitle = useMemo(() => {
    return qlikObject?.title || "";
  }, [qlikObject]);

  const qlikKpiMeasureTitle = useMemo(() => {
    return qlikObject?.qHyperCube?.qMeasureInfo?.[0]?.qFallbackTitle || "";
  }, [qlikObject]);

  const qlikObjectSubtitle = useMemo(() => {
    return qlikObject?.subtitle || "";
  }, [qlikObject]);

  const qlikObjectFootnote = useMemo(() => {
    return qlikObject?.footnote || "";
  }, [qlikObject]);

  const qlikObjectColorMapRef = useMemo(() => {
    return qlikObject?.qHyperCube?.qDimensionInfo[0]?.coloring?.colorMapRef || '';
  }, [qlikObject]);

  return {
    isQlikLoading,
    qlikObject,
    qlikObjectData,
    qlikKpiObjectValue,
    qlikObjectTitle,
    qlikKpiMeasureTitle,
    qlikObjectSubtitle,
    qlikObjectFootnote,
    qlikObjectColorMapRef
  };
};